import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';

export interface ConfirmationModalConfig {
  title: string;
  message: string;
  iconClass?: string;
  iconColor?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  confirmButtonClass?: string;
  cancelButtonClass?: string;
  showCancelButton?: boolean;
  showConfirmButton?: boolean;
  animationClass?: string;
  loading?: boolean;
  loadingText?: string;
  // Additional customization options following batchallocate pattern
  customButtonClasses?: {
    confirm?: string;
    cancel?: string;
  };
  showLoadingSpinner?: boolean;
  loadingSpinnerClass?: string;
}

@Component({
    selector: 'gtw-confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    styleUrls: ['./confirmation-modal.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ConfirmationModalComponent implements OnInit {
  
  @Input() config: ConfirmationModalConfig = {
    title: 'Confirm Action',
    message: 'Are you sure you want to proceed?',
    iconClass: 'fa fa-sign-out',
    iconColor: 'txt-color-orange-dark',
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
    confirmButtonClass: 'btn-danger',
    cancelButtonClass: 'btn-default',
    showCancelButton: true,
    showConfirmButton: true,
    animationClass: 'animated fadeIn fast',
    loading: false,
    loadingText: 'Processing...',
    showLoadingSpinner: true,
    loadingSpinnerClass: 'fa fa-spinner fa-spin'
  };

  @Input() visible: boolean = false;

  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
    // Merge with default values if not provided - following batchallocate pattern
    this.config = {
      iconClass: 'fa fa-sign-out',
      iconColor: 'txt-color-orange-dark',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn-danger',
      cancelButtonClass: 'btn-default',
      showCancelButton: true,
      showConfirmButton: true,
      animationClass: 'animated fadeIn fast',
      loading: false,
      loadingText: 'Processing...',
      showLoadingSpinner: true,
      loadingSpinnerClass: 'fa fa-spinner fa-spin',
      customButtonClasses: {
        confirm: 'confirm-button',
        cancel: 'cancel-button'
      },
      ...this.config
    };
  }

  onConfirm(): void {
    this.confirmed.emit();
  }

  onCancel(): void {
    this.cancelled.emit();
  }

  onClose(): void {
    this.closed.emit();
  }

  // Helper method to get button classes - following batchallocate pattern
  getButtonClasses(baseClass?: string, buttonType?: 'confirm' | 'cancel'): string {
    let classes = `${baseClass || 'btn-default'} btn-xs`;
    
    // Add custom button classes if provided
    // if (buttonType && this.config.customButtonClasses) {
    //   const customClass = this.config.customButtonClasses[buttonType];
    //   if (customClass) {
    //     classes += ` ${customClass}`;
    //   }
    // }
    
    return classes;
  }

  // Helper method to get icon classes
  getIconClasses(): string {
    return `${this.config.iconClass} ${this.config.iconColor}`;
  }

  // Helper method to get animation classes
  getAnimationClasses(): string {
    return this.config.animationClass || 'animated fadeIn fast';
  }

  // Helper method to get loading spinner classes
  getLoadingSpinnerClasses(): string {
    return this.config.loadingSpinnerClass || 'fa fa-spinner fa-spin';
  }

  // Helper method to check if loading spinner should be shown
  shouldShowLoadingSpinner(): boolean {
    return !!(this.config.loading && this.config.showLoadingSpinner !== false);
  }
}